export const studentsConst = {
    LOADED: 'STUDENTS_LOADED',
    UNLOADED: 'STUDENTS_UNLOADED'
};
